export default "__VITE_ASSET__BEGfkQ_V__"